<template>
  <div class='register'>
    <div class='ly-card'>
      <el-button type='primary' size='medium' v-if="hasPermission('reg_add')" @click='() => openDigFrom(true)'
      >新增
      </el-button
      >
      <el-button type='primary' size='medium' @click.native='exportExcel' v-if="hasPermission('reg_export')"
      >导出
      </el-button
      >
      <el-button type='primary' size='medium' @click.native='dialogVisible = true'>显示列名</el-button>
      <el-popover
        placement='bottom-start'
        width='740'
        trigger='click'
        class='m-l-10 m-r-10'
        :visible-arrow='false'
        v-model='searchVisible'
      >
        <div class='high-search'>
          <ly-form
            class='ly-form'
            :formConfig='searchFormConfig'
            :formKeys='searchFormKeys'
            ref='lySearchForm'
          ></ly-form>
          <div class='btn-group flex'>
            <el-button size='medium' @click='reset'>重置</el-button>
            <el-button type='primary' size='medium' @click='highSearch'>查询</el-button>
          </div>
        </div>
        <el-button slot='reference' size='medium' type='primary'>
          高级查询
          <i class='el-icon-arrow-down el-icon--right'></i>
        </el-button>
      </el-popover>
      <div class='fr'>
        <el-date-picker
          v-model='searchFormData.date'
          type='daterange'
          range-separator='至'
          start-placeholder='注册开始日期'
          end-placeholder='注册结束日期'
          value-format='yyyy-MM-dd'
        >
        </el-date-picker>
        <el-button class='m-l-10' type='primary' size='medium' @click='search'>查询</el-button>
      </div>
    </div>
    <div class='content ly-card'>
      <ly-table
        :getTableData='getTableData'
        :tableHeader='tableHeader'
        :searchFormData='searchFormData'
        ref='lyTable'
        class='width-full'
      >
        <template v-slot:age='row'>{{ row.age !== null ? `${ row.age }岁` : '一' }}</template>
        <template v-slot:action='row'>
          <el-button @click="editRow(row, 'base')" type='text' v-if="hasPermission('reg_edit')" size='mini'
          >修改
          </el-button
          >
          <el-button @click="editRow(row, 'contact')" type='text' v-if="hasPermission('reg_contact')" size='mini'
          >联系人
          </el-button
          >
          <el-button
            @click='delRow(row)'
            type='text'
            class='el-button--danger'
            v-if="hasPermission('reg_delete')"
            size='mini'
          >删除
          </el-button
          >
        </template>
      </ly-table>
    </div>
    <set-table-header
      @close='dialogVisible = false'
      @change='setShowField'
      itemKey='reguserlist'
      :dialogVisible='dialogVisible'
      :tableHeader='tableHeader'
    ></set-table-header>
    <el-dialog
      :title="isBase ? `${defaultFormItem.id ? '修改' : '新增'}用户` : '联系人信息'"
      :visible.sync='dialogUser'
      @opened='openEvent'
      @close='closeEvent'
      width='1400px'
      class='ly-dialog'
    >
      <template v-if='isBase'>
        <ly-form
          :defaultFormItem='defaultFormItem'
          :formConfig='formConfig'
          :formKeys='formKeys'
          class='ly-form reg-user'
          ref='lyForm'
        >
          <template v-slot:password='{ formData, item }'>
            <el-input
              type='password'
              :placeholder='item.placeholder'
              v-model='formData.password'
              :disabled='!!defaultFormItem.id'
            >
            </el-input>
            <el-button class='m-l-10' v-if='defaultFormItem.id' type='text' size='medium' @click.native='resetPwd'
            >重置密码
            </el-button
            >
          </template>
          <template v-slot:often_address='{ formData,item }'>
            <el-input
              type='text'
              :placeholder='item.placeholder'
              v-model='formData.often_address'
              :disabled='!!defaultFormItem.id'
            >
            </el-input>
          </template>
          <template v-slot:head_url='{ formData }'>
            <img :src='`${baseUrl}/${formData.head_url}`' v-show='formData.head_url' width='200px' />
            <upload
              @successCBK="value => mediaChange('head_url', value, formData)"
              accept='.jpg, .jpeg, .png, .gif, .bmp'
            />
          </template>
          <template v-slot:id_card_url='{ formData }'>
            <img :src='`${baseUrl}/${formData.id_card_url}`' v-show='formData.id_card_url' width='200px' />
            <upload
              @successCBK="value => mediaChange('id_card_url', value, formData)"
              accept='.jpg, .jpeg, .png, .gif, .bmp'
            />
          </template>
        </ly-form>
      </template>
      <template v-else>
        <el-button type='primary' icon='el-icon-plus' @click.native='openRs'></el-button>
        <ly-table
          :getTableData='getTableDataRs'
          :tableHeader='tableHeaderRs'
          :searchFormData='searchFormDataRs'
          :paginConfig='paginConfigRs'
          @dataChange='dataChange'
          ref='lyTableRs'
          class='width-full'
        >
          <template v-slot:often_address='row'>
            <el-button @click='setBabyView(row,1)' type='text'>查看常住地址</el-button>
          </template>
          <template v-slot:cohabitation='row'>
            <el-button @click='setBabyView(row,2)' type='text'>查看共居人</el-button>
          </template>
          <template v-slot:transfer='row'>
            <el-button @click='setBabyView(row,3)' type='text'>查看主要接送人</el-button>
          </template>
          <template v-slot:action='row'>
            <el-button @click.native='editRowRs(row)' type='primary' size='mini'>修改</el-button>
            <el-button @click.native='delRowRs(row)' type='danger' size='mini'>删除</el-button>
          </template>
        </ly-table>
      </template>
      <span slot='footer' class='dialog-footer' v-if='isBase'>
        <el-button @click='dialogUser = false'>取 消</el-button>
        <el-button type='primary' @click.native='closeDg'>保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="`${defaultRsFormItem.id ? '修改' : '新增'}联系人`"
      append-to-body
      :visible.sync='isAddRsUser'
      @close='clearRs'
      width='800px'
      class='register-contact-form'
    >
      <ly-form
        :defaultFormItem='defaultRsFormItem'
        :formConfig='formConfigRs'
        :formKeys='formKeysRs'
        class='ly-form'
        ref='lyFormRs'
      >
        <template v-slot:often_address>
          <el-button @click='setBaby(1)' style='width: 212px' plain>设置常住地址</el-button>
        </template>
        <template v-slot:cohabitation>
          <el-button @click='setBaby(2)' style='width: 212px' plain>设置共居人信息</el-button>
        </template>
        <template v-slot:transfer>
          <el-button @click='setBaby(3)' style='width: 212px' plain>设置主要接送人信息</el-button>
        </template>
        <template v-slot:head_url='{ formData }'>
          <img :src='`${baseUrl}/${formData.head_url}`' v-if='formData.head_url' width='200px' />
          <upload
            @successCBK="value => mediaChange('head_url', value, formData)"
            accept='.jpg, .jpeg, .png, .gif, .bmp'
          />
        </template>
        <template v-slot:id_card_url='{ formData }'>
          <img :src='`${baseUrl}/${formData.id_card_url}`' v-if='formData.id_card_url' width='200px' />
          <upload
            @successCBK="value => mediaChange('id_card_url', value, formData)"
            accept='.jpg, .jpeg, .png, .gif, .bmp'
          />
        </template>
      </ly-form>
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' @click.native='saveRs' :loading='loading'>保存</el-button>
        <el-button @click.native='cancelRs'>取消</el-button>
      </span>
    </el-dialog>
    <el-drawer :title='(viewDrawerInfo ? "" : "设置")+"常住地址"' size='480px' :visible.sync='drawer1' :before-close='handleDrawerClose'>
      <div class='drawer_content'>
        <div class='drawer_content_item'>
          <span class='content_item_title'>省：</span>
          <el-select class='select_item' v-model='babyAddress.province' placeholder='请选择省' @change='changePro'>
            <el-option v-for='item in addressData' :key='item.code' :label='item.name' :value='item.name'></el-option>
          </el-select>
        </div>
        <div class='drawer_content_item'>
          <span class='content_item_title'>市：</span>
          <el-select class='select_item' v-model='babyAddress.city' placeholder='请选择市' @change='changeCity'>
            <el-option v-for='item in cityData' :key='item.code' :label='item.name' :value='item.name'></el-option>
          </el-select>
        </div>
        <div class='drawer_content_item'>
          <span class='content_item_title'>区/县：</span>
          <el-select class='select_item' v-model='babyAddress.district' placeholder='请选择区'>
            <el-option v-for='item in areaData' :key='item.code' :label='item.name' :value='item.name'></el-option>
          </el-select>
        </div>
        <div class='drawer_content_item'>
          <span class='content_item_title'>街道：</span
          >
          <el-input placeholder='请输入所在街道' class='select_item' v-model='babyAddress.street'></el-input>
        </div>
        <div class='drawer_content_item'>
          <span class='content_item_title'>详细地址：</span
          >
          <el-input placeholder='请输入详细地址' class='select_item' v-model='babyAddress.detail_address'></el-input>
        </div>
      </div>
      <div class='drawer_buttom' v-if='!viewDrawerInfo'>
        <el-button @click='sureSet(1)' type='primary'>确定</el-button>
      </div>
    </el-drawer>
    <el-drawer :title='(viewDrawerInfo ? "" : "设置")+"共居人信息"' size='480px' :visible.sync='drawer2' :before-close='handleDrawerClose'>
      <div class='drawer_content'>
        <el-collapse v-model='activeName'>
          <el-collapse-item
            v-for='(item, index) in cohabitant_temp'
            :title='`共居人${index + 1}`'
            :key='index'
            :name='`${index}`'
          >
            <div class='drawer_content_item'>
              <span class='content_item_title'>关系：</span
              >
              <el-input placeholder='请输入与共居人的关系' class='select_item' v-model='item.relation'></el-input>
            </div>
            <div class='drawer_content_item'>
              <span class='content_item_title'>姓名：</span
              >
              <el-input placeholder='请输入共居人姓名' class='select_item' v-model='item.name'></el-input>
            </div>
            <div class='drawer_content_item'>
              <span class='content_item_title'>电话：</span
              >
              <el-input placeholder='请输入共居人电话' class='select_item' v-model='item.phone'></el-input>
            </div>
            <el-button v-if='!viewDrawerInfo' @click='sub(index, 1)' type='danger'>删除</el-button>
          </el-collapse-item>
        </el-collapse>
        <div class='drawer_buttom1' v-if='!viewDrawerInfo'>
          <el-button @click='add(1)' style='width: 70px; margin: 30px auto' type='success'>添加</el-button>
          <el-button @click='sureSet(2)' style='width: 70px; margin: 30px auto' type='primary'>确定</el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer :title='(viewDrawerInfo ? "" : "设置")+"主要接送人信息"' size='480px' :visible.sync='drawer3' :before-close='handleDrawerClose'>
      <div class='drawer_content'>
        <el-collapse v-model='activeName'>
          <el-collapse-item
            v-for='(item, index) in pickup_person_temp'
            :title='`主要接送人${index + 1}`'
            :key='index'
            :name='`${index}`'
          >
            <div class='drawer_content_item'>
              <span class='content_item_title'>关系：</span
              >
              <el-input placeholder='请输入与接送人的关系' class='select_item' v-model='item.relation'></el-input>
            </div>
            <div class='drawer_content_item'>
              <span class='content_item_title'>姓名：</span
              >
              <el-input placeholder='请输入接送人姓名' class='select_item' v-model='item.name'></el-input>
            </div>
            <div class='drawer_content_item'>
              <span class='content_item_title'>电话：</span
              >
              <el-input placeholder='请输入接送人电话' class='select_item' v-model='item.phone'></el-input>
            </div>
            <div class='drawer_content_item'>
              <span class='content_item_title'>常住地址：</span
              >
              <el-input placeholder='请输入接送人常住地址' class='select_item' v-model='item.address'></el-input>
            </div>
            <el-button @click='sub(index, 0)' type='danger' v-if='!viewDrawerInfo'>删除</el-button>
          </el-collapse-item>
        </el-collapse>
        <div class='drawer_buttom1' v-if='!viewDrawerInfo'>
          <el-button @click='add(0)' style='width: 70px; margin: 30px auto' type='success'>添加</el-button>
          <el-button @click='sureSet(3)' style='width: 70px; margin: 30px auto' type='primary'>确定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { Dialog, DatePicker, Input, Popover, Drawer, Select, Collapse, CollapseItem, Option } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import SetTableHeader from '@/components/SetTableHeader';
import { registerUserFormItem, registerUserSearchFormItem, registerUserRelationsFormItem } from '@/utils/formConfig';
import { regUserTable, regUserRelationsTable } from '@/utils/tableHeader';
import { sys } from '@/api';
import Upload from '@/components/Upload';
import perMixin from '@/utils/perMixin';
import utils from '@/utils/utils';
import pattern from '@/utils/pattern';
import address from '@/utils/address.json'; // 全国省市区街道数据

export default {
  name: 'UserRegisterUser',
  mixins: [perMixin],
  components: {
    LyTable,
    LyForm,
    SetTableHeader,
    ElDialog: Dialog,
    ElPopover: Popover,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElDatePicker: DatePicker,
    Upload,
    elDrawer: Drawer,
    elCollapse: Collapse,
    elCollapseItem: CollapseItem
  },
  data() {
    return {
      loading: false,
      checkTabs: 'base',
      tableHeader: regUserTable,
      searchFormData: {
        date: []
      },
      getTableData: sys.getrRegisterUser,
      dialogVisible: false,
      dialogUser: false,
      formKeys: {},
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 12
      },
      searchFormConfig: {
        'label-width': '120px',
        'label-position': 'left',
        itemSpan: 12
      },
      searchFormKeys: registerUserSearchFormItem,
      searchVisible: false,
      // 用户关系
      tableHeaderRs: regUserRelationsTable,
      getTableDataRs: sys.getRegisterUserRelation,
      searchFormDataRs: {},
      paginConfigRs: {
        isHide: true
      },
      defaultRsFormItem: {},
      formConfigRs: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 12
      },
      formKeysRs: registerUserRelationsFormItem,
      totalRs: 0,
      isAddRsUser: false,
      baseUrl: '',
      drawer1: false,
      drawer2: false,
      drawer3: false,
      province: '', // 省
      city: '', // 市
      district: '', // 区
      street: '', // 街道
      detail_address: '', // 详细地址
      cohabitant: [{ relation: '', name: '', phone: '' }], // 共居人情况
      pickup_person: [{ relation: '', name: '', phone: '', address: '' }], // 主要接送人情况

      // 设置常住地址页数据
      addressData: [], //  省数据
      cityData: [], //  市数据
      areaData: [], // 区数据
      babyAddress: {
        province: '', // 省
        city: '', // 市
        district: '', // 区
        street: '', // 街道
        detail_address: '' // 详细地址}
      },
      // 设置共居人情况页数据
      activeName: ['0'], // 当前激活的折叠面板
      cohabitant_temp: [{ relation: '', name: '', phone: '' }], // 共居人情况
      // 设置主要接送人情况页数据
      pickup_person_temp: [{ relation: '', name: '', phone: '', address: '' }], // 主要接送人情况
      viewDrawerInfo: false
    };
  },
  computed: {
    isBase() {
      return this.checkTabs === 'base';
    }
  },
  mounted() {
    this.init();
    this.search();
  },
  methods: {
    async init() {
      // const resEduPro = teacher.education();
      const resRsPro = sys.userRelation();
      const resIdTypePro = sys.getIdCardType();
      const awGResPro = sys.userGenderChoose();
      const awgGrade = sys.gradeChoose();
      // const resEdu = await resEduPro;
      const resIdType = await resIdTypePro;
      const awGRes = await awGResPro;
      const resRs = await resRsPro;
      const resGrade = await awgGrade;
      // if (resEdu) {
      //   registerUserFormItem.education.options.select = resEdu.data;
      // }
      if (resIdType) {
        registerUserFormItem.id_card_type.options.select = resIdType.data;
        registerUserRelationsFormItem.id_card_type.options.select = resIdType.data;
      }
      if (awGRes) {
        registerUserFormItem.gender.options.select = awGRes.data;
        registerUserRelationsFormItem.gender.options.select = awGRes.data;
      }
      if (resRs) {
        registerUserRelationsFormItem.relation.options.select = resRs.data;
      }
      if (resGrade) {
        registerUserRelationsFormItem.grade.options.select = resGrade.data;
      }
      this.formKeys = registerUserFormItem;
      this.formKeysRs = registerUserRelationsFormItem;
      // 获取多媒体信息地址
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
    },
    handleDrawerClose() {
      if (this.viewDrawerInfo) {
        this.viewDrawerInfo = false;
      }
      this.drawer1 = false;
      this.drawer2 = false;
      this.drawer3 = false;
    },
    setBabyView(row, value) {
      this.viewDrawerInfo = true;
      switch (value) {
        case 1:
          this.babyAddress = {
            province: row.province || '',
            city: row.city || '',
            district: row.district || '',
            street: row.street || '',
            detail_address: row.detail_address || ''
          };
          // 省市区数据初始化
          this.addressData = address;
          if (this.province) {
            this.cityData = this.addressData.filter(item => item.name === this.province)[0].children || '';
          }
          if (this.city) {
            this.areaData = this.cityData.filter(item => item.name === this.city)[0].children || '';
          }
          this.drawer1 = true;
          break;
        case 2:
          this.cohabitant_temp = JSON.parse(JSON.stringify(row.cohabitant));
          this.drawer2 = true;
          break;
        case 3:
          this.pickup_person_temp = JSON.parse(JSON.stringify(row.pickup_person));
          this.drawer3 = true;
          break;
        default:
          break;
      }
    },
    setBaby(value) {
      switch (value) {
        case 1:
          this.babyAddress = {
            province: this.province,
            city: this.city,
            district: this.district,
            street: this.street,
            detail_address: this.detail_address
          };
          this.drawer1 = true;
          break;
        case 2:
          this.cohabitant_temp = JSON.parse(JSON.stringify(this.cohabitant));
          this.drawer2 = true;
          break;
        case 3:
          this.pickup_person_temp = JSON.parse(JSON.stringify(this.pickup_person));
          this.drawer3 = true;
          break;
        default:
          break;
      }
    },
    sureSet(value) {
      let temp1 = false;
      let temp2 = false;
      const reg = /^1[3-9]\d{9}$/;
      if (value === 1) {
        if (
          !this.babyAddress.province
          || !this.babyAddress.city
          || !this.babyAddress.district
          || !this.babyAddress.street
          || !this.babyAddress.detail_address
        ) {
          this.$message.error('请完整填写信息！');
          return;
        }
        this.province = this.babyAddress.province;
        this.city = this.babyAddress.city;
        this.district = this.babyAddress.district;
        this.street = this.babyAddress.street;
        this.detail_address = this.babyAddress.detail_address;
        this.drawer1 = false;
      } else if (value === 2) {
        if (this.cohabitant_temp.length) {
          try {
            // eslint-disable-next-line array-callback-return
            this.cohabitant_temp.map((item, index) => {
              if (!item.relation || !item.name || !item.phone) {
                this.$message.error(`请完整填写共居人${index + 1}的信息！`);
                temp1 = false;
                throw Error;
              }
              if (!reg.test(item.phone)) {
                this.$message.error(`共居人${index + 1}的手机号码格式错误！`);
                temp1 = false;
                throw Error;
              }
              temp1 = true;
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$message.error('请添加至少一条信息！');
          return;
        }
        if (temp1) {
          this.cohabitant = this.cohabitant_temp;
          this.drawer2 = false;
        }
      } else if (value === 3) {
        if (this.pickup_person_temp.length) {
          try {
            this.pickup_person_temp.map((item, index) => {
              if (!item.relation || !item.name || !item.phone || !item.address) {
                this.$message.error(`请完整填写主要接送人${index + 1}的信息！`);
                temp2 = false;
                throw Error;
              }
              if (!reg.test(item.phone)) {
                this.$message.error(`主要接送人${index + 1}的手机号码格式错误！`);
                temp2 = false;
                throw Error;
              }
              temp2 = true;
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$message.error('请添加至少一条信息！');
          return;
        }
        if (temp2) {
          this.pickup_person = this.pickup_person_temp;
          this.drawer3 = false;
        }
      }
    },
    // 省份更改
    changePro(e) {
      // 从省中过滤出市的数据
      this.cityData = this.addressData.filter(item => item.name === e)[0].children;
      // 省发生改变的时候 清空输入框市区街道的内容
      this.babyAddress.city = '';
      this.babyAddress.district = '';
      this.areaData = [];
    },
    // 市更改
    changeCity(e) {
      // 获取到市的数据
      this.areaData = this.cityData.filter(item => item.name === e)[0].children;
      // 清空数据后面对应数组的数据
      this.babyAddress.district = '';
    },
    // 删除一个信息
    sub(index, type) {
      if (type) {
        this.cohabitant_temp.splice(index, 1);
      } else {
        this.pickup_person_temp.splice(index, 1);
      }
    },
    // 添加一个信息
    add(type) {
      if (type) {
        this.cohabitant_temp.push({ relation: '', name: '', phone: '' });
      } else {
        this.pickup_person_temp.push({ relation: '', name: '', phone: '', address: '' });
      }
    },
    exportExcel() {
      sys
        .exportRegister({
          params: this.searchFormData
        })
        .then(data => {
          if (data) utils.downloadData(data, '注册用户列表');
        });
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    openDigFrom(isAdd) {
      this.dialogUser = true;
      if (isAdd) {
        this.defaultFormItem = {};
        this.checkTabs = 'base';
      }
    },
    openRs() {
      this.province = '';
      this.city = '';
      this.district = '';
      this.street = '';
      this.detail_address = '';
      this.babyAddress = {
        province: '',
        city: '',
        district: '',
        street: '',
        detail_address: ''
      };
      this.cohabitant = [];
      this.pickup_person = [];
      this.loading = false;
      this.isAddRsUser = true;
      this.defaultRsFormItem = {};
      // 省市区数据初始化
      this.addressData = address;
      this.cityData = this.addressData.filter(item => item.name === this.province)[0].children || '';
      this.areaData = this.cityData.filter(item => item.name === this.city)[0].children || '';
    },
    closeDg() {
      if (this.isBase) {
        this.addRgUser();
      } else {
        this.isAddRsUser = false;
        this.dialogUser = false;
      }
    },
    async addRgUser() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (data.id_card_type === 1 && !pattern.idCard.test(data.id_card_no)) {
          this.$message.warning('请输入正确的身份证号！');
          return;
        }
        if (data.id_card_type === 2 && !pattern.PASSPORT_REGEX.test(data.id_card_no)) {
          this.$message.warning('请输入正确的护照！');
          return;
        }
        if (data.id_card_type === 3 && !pattern.TAIWAN_ID_CARD_REGEX.test(data.id_card_no)) {
          this.$message.warning('请输入正确的台胞证！');
          return;
        }
        if (data.id_card_type === 4 && !pattern.HK_MACAO_PASS_REGEX.test(data.id_card_no)) {
          this.$message.warning('请输入正确的港澳通行证！');
          return;
        }
        if (this.defaultFormItem.id) {
          // 修改
          delete data.password;
          res = await sys.controlRegisterUser({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: data
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await sys.registerUser({ params: { ...data, user_id: this.defaultFormItem.user_id }, methold: 'post' });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogUser = false;
        }
      }
    },
    delRow(row) {
      this.$confirm(`确认删除-${row.username}？`)
        .then(() => {
          sys
            .controlRegisterUser({
              methold: 'delete',
              params: row,
              id: row.id
            })
            .then(res => {
              if (res) {
                this.search();
                this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
              }
            });
        })
        .catch(() => {
        });
    },
    editRow(row, key) {
      this.checkTabs = key;
      this.defaultFormItem = { ...row, password: 'Cncc123456' };
      this.searchFormDataRs = { ...this.searchFormData, id: row.id };
      this.openDigFrom();
    },
    openEvent() {
      if (this.isBase) this.$refs.lyForm.$refs.lyForm.clearValidate();
      else {
        this.searchRs();
      }
    },
    closeEvent() {
      if (this.checkTabs !== 'base') this.$refs.lyTableRs.clearData();
    },
    search() {
      if (this.searchFormData.date && this.searchFormData.date.length) {
        [this.searchFormData.start_date, this.searchFormData.end_date] = this.searchFormData.date;
      } else {
        delete this.searchFormData.start_date;
        delete this.searchFormData.end_date;
      }
      this.$refs.lyTable.setData();
    },
    async highSearch() {
      const { data } = await this.$refs.lySearchForm.getFormData();
      this.searchFormData = { ...data };
      this.search();
      this.searchVisible = false;
    },
    dataChange({ total }) {
      this.totalRs = total || 0;
    },
    searchRs() {
      if (this.defaultFormItem.id) {
        this.$refs.lyTableRs.setData();
      }
    },
    cancelRs() {
      this.isAddRsUser = false;
      this.defaultRsFormItem = {};
    },
    async delRowRs(row) {
      const res = await sys.controlRegisterUserRelation({
        methold: 'delete',
        id: row.id
      });
      if (res) {
        this.$message.success(res.msg || '删除成功');
        this.searchRs();
      }
    },
    editRowRs(row) {
      console.log('修改item---', row);
      this.province = row.province || '';
      this.city = row.city || '';
      this.district = row.district || '';
      this.street = row.street || '';
      this.detail_address = row.detail_address || '';
      this.babyAddress = {
        province: row.province || '',
        city: row.city || '',
        district: row.district || '',
        street: row.street || '',
        detail_address: row.detail_address || ''
      };
      this.cohabitant = row.cohabitant || [];
      this.pickup_person = row.pickup_person || [];
      this.defaultRsFormItem = { ...row, id_card_url: row.document_photo };
      this.isAddRsUser = true;
      this.loading = false;
      // 省市区数据初始化
      this.addressData = address;
      this.cityData = this.addressData.filter(item => item.name === this.province)[0].children || '';
      this.areaData = this.cityData.filter(item => item.name === this.city)[0].children || '';
    },
    async saveRs() {
      let { data, valid } = await this.$refs.lyFormRs.getFormData();
      if (valid) {
        let res = null;
        if (data.id_card_type === 1 && !pattern.idCard.test(data.id_card_no)) {
          this.$message.warning('请输入正确的身份证号！');
          return;
        }
        if (data.id_card_type && data.id_card_type !== 1 && !data.id_card_url) {
          this.$message.warning('不是身份证的证件需要上传证件照片！');
          return;
        }
        if (!this.babyAddress.province || !this.babyAddress.city || !this.babyAddress.district || !this.babyAddress.street || !this.babyAddress.detail_address) {
          this.$message.warning('请完整填写常住地址信息！');
          return;
        }
        if (!this.cohabitant || !this.cohabitant.length) {
          this.$message.warning('请至少填写一个共居人信息！');
          return;
        }
        if (!this.pickup_person || !this.pickup_person.length) {
          this.$message.warning('请至少填写一个主要接送人信息！');
          return;
        }
        data = {
          ...data,
          province: this.province,
          city: this.city,
          district: this.district,
          street: this.street,
          detail_address: this.detail_address,
          cohabitant: this.cohabitant,
          pickup_person: this.pickup_person
        };
        this.loading = true;
        if (this.defaultRsFormItem.id) {
          // 修改
          res = await sys.controlRegisterUserRelation({
            methold: 'put',
            id: this.defaultRsFormItem.id,
            params: data
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          console.log('data:', data);
          // 新增
          res = await sys.addRegisterUserRelation({ params: data, id: this.defaultFormItem.id });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTableRs.setData();
          this.cancelRs();
        }
        this.loading = false;
      }
    },
    async resetPwd() {
      const res = await sys.resetPassword({
        id: this.defaultFormItem.id,
        params: {
          password: 'Cncc123456'
        }
      });
      if (res) {
        this.$store.dispatch('msg/showMsg', '密码已被重置为：Cncc123456');
      }
    },
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    },
    clearRs() {
      this.$refs.lyFormRs.$refs.lyForm.resetFields();
    },
    reset() {
      this.$refs.lySearchForm.resetFields();
      this.searchFormData = {};
      this.search();
    }
  }
};
</script>

<style lang='less'>
.register-contact-form {
  .el-input {
    width: 212px;
  }
}

.register {
  .ly-form.reg-user {
    .el-input {
      width: 212px;
    }
  }

  .date-short {
    width: 138px;

    .el-input__inner {
      padding-left: 30px;
    }
  }

  .edit-row {
    display: flex;
    align-items: center;
    margin: 15px 0;

    .el-form-item {
      margin-bottom: 0;
    }

    .index {
      width: 50px;
      padding-left: 5px;
    }

    .el-button--mini {
      padding: 12px 15px;
    }
  }
}

.high-search {
  .ly-form {
    .el-input {
      width: 212px;
    }
  }
}

.ly-dialog .el-dialog__body {
  padding: 10px 20px;
}

.drawer_content {
  width: 400px;
  height: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.drawer_content .content_item_title {
  display: inline-block;
  width: 100px;
  font-size: 16px;
}

.drawer_content .select_item {
  width: 300px;
  margin-bottom: 20px;
}

.drawer_buttom {
  display: flex;
  justify-content: center;
}

.drawer_buttom1 {
  width: 300px;
  margin: auto auto 0 auto;
  display: flex;
  justify-content: space-around;
}

.el-collapse-item__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-collapse-item__header {
  width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
